const closeHeaderMore = (root) => {
  const trigger = root.querySelector("[data-header-more-trigger]")
  const menu = root.querySelector("[data-header-more-menu]")
  if (!trigger || !menu) return

  menu.hidden = true
  trigger.setAttribute("aria-expanded", "false")
  trigger.classList.remove("is-open")

  const wrap = root.closest(".backoffice-table-wrap")
  if (wrap && !wrap.querySelector("[data-header-more-trigger].is-open")) {
    wrap.classList.remove("is-row-more-open")
  }

  root.closest("tr")?.classList.remove("is-row-more-open")
}

const openHeaderMore = (root) => {
  const trigger = root.querySelector("[data-header-more-trigger]")
  const menu = root.querySelector("[data-header-more-menu]")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")

  const wrap = root.closest(".backoffice-table-wrap")
  if (wrap) wrap.classList.add("is-row-more-open")

  root.closest("tr")?.classList.add("is-row-more-open")
}

const bindHeaderMore = (root) => {
  if (root.dataset.headerMoreBound === "true") return
  root.dataset.headerMoreBound = "true"

  const trigger = root.querySelector("[data-header-more-trigger]")
  const menu = root.querySelector("[data-header-more-menu]")
  if (!trigger || !menu) return

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (menu.hidden) {
      document.querySelectorAll("[data-header-more]").forEach((other) => {
        if (other !== root) closeHeaderMore(other)
      })
      openHeaderMore(root)
    } else {
      closeHeaderMore(root)
    }
  })
}

const initBackofficeHeaderMore = () => {
  document.querySelectorAll("[data-header-more]").forEach(bindHeaderMore)
}

document.addEventListener("click", () => {
  document.querySelectorAll("[data-header-more]").forEach(closeHeaderMore)
})

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-header-more]").forEach((root) => {
    closeHeaderMore(root)
    root.dataset.headerMoreBound = "false"
  })
})

export { initBackofficeHeaderMore }
